import { useMemo } from 'react';

import type { Filter } from 'common/types/SortAndFilter';

const CATEGORY_SECTION_KEY = 'category';

interface UseFilterListProps {
  filters: Filter[];
  excludeCategory?: boolean;
  showCategoriesAsFilter?: boolean;
}

const getFilterList = ({
  filters,
  showCategoriesAsFilter,
  excludeCategory,
}: UseFilterListProps) => {
  if (showCategoriesAsFilter) {
    return filters.filter(item => item.key === CATEGORY_SECTION_KEY);
  } else if (excludeCategory) {
    return filters.filter(item => item.key !== CATEGORY_SECTION_KEY);
  }

  return filters;
};

export const useFilterList = (props: UseFilterListProps) => {
  const { filters, showCategoriesAsFilter, excludeCategory } = props;

  return useMemo(
    () => getFilterList({ filters, showCategoriesAsFilter, excludeCategory }),
    [filters, showCategoriesAsFilter, excludeCategory]
  );
};
